import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUserCog } from "@fortawesome/free-solid-svg-icons"

export const UserCog = (props) => {
  return <FontAwesomeIcon faIcon={faUserCog} {...props} />
}
